import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode : 'history',
  routes: [
    {
      path: '/bxgj',
      component: () =>import('@/views/bxgj/Layout'),
      redirect: '/bxgj/orderCreate',
      name: 'Bxgj',
      meta: { title: '报修管家' },
      children: [
      {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/home/IndexDoor'),
          meta: {title: '首页'}
        },
        {
          path: 'orderCreate',
          name: 'OrderCreate',
          component: () => import('@/views/order/OrderCreate'),
          meta: {
              title: '报修',
              keepAlive: true,
          }
        },
        {
             path: '/order',
             component: () => import('@/views/order/Layout'),
             redirect: '/order/orderUnderway',
             name: 'Order',
             meta: { title: '订单'},
             children: [
                {
                 path: 'orderBeCheck',
                 name: 'OrderBeCheck',
                 component: () => import('@/views/order/OrderBeCheck'),
                 meta: { title: '审核单'}
                },
                {
                  path: 'orderUnderway',
                  name: 'OrderUnderway',
                  component: () => import('@/views/order/OrderUnderway'),
                  meta: { title: '订单'}
                },
                {
                  path: 'orderPendingAcceptance',
                  name: 'OrderPendingAcceptance',
                  component: () => import('@/views/order/OrderPendingAcceptance'),
                  meta: { title: '订单'}
                },
                {
                  path: 'orderFinish',
                  name: 'OrderFinish',
                  component: () => import('@/views/order/OrderFinish'),
                  meta: { title: '订单'}
                },
            ],
        },
        {
          path: '/user/userCenter',
          name: 'UserCenter',
          component: () => import('@/views/user/UserCenter'),
          meta: { title: '我的'}
        },
       ]
    },
    {
     path: '/orderCreateSuccess',
     component: () => import('@/views/order/OrderCreateSuccess'),
     name: 'orderCreateSuccess',
     meta: { title: '报修成功'},
    },
    {
     path: '/bind',
     component: () => import('@/views/bind/Layout'),
     redirect: '/bind/bindPhone',
     name: 'Bind',
     meta: { title: '绑定'},
     children: [
        {
         path: 'bindPhone',
         component: () => import('@/views/bind/BindPhone'),
         name: 'bindPhone',
         meta: { title: '手机绑定'},
        },
        {
         path: 'bindAccount',
         component: () => import('@/views/bind/BindAccount'),
         name: 'BindAccount',
         meta: { title: '账号绑定'},
        },
     ]
    },
    {
     path: '/bindSuccess',
     component: () => import('@/views/bind/BindSuccess'),
     name: 'BindSuccess',
     meta: { title: '绑定成功'},
    },
    {
     path: '/register',
     component: () => import('@/views/bind/Register'),
     name: 'Register',
     meta: { title: '企业注册'},
    },
    {
     path: '/registerVersion',
     component: () => import('@/views/bind/RegisterVersion'),
     name: 'RegisterVersion',
     meta: { title: '选择身份'},
    },

    {
     path: '/orderDetail',
     component: () => import('@/views/order/OrderDetail'),
     name: 'OrderDetail',
     meta: { title: '订单详情'},
    },
    {
     path: '/orderProgress',
     component: () => import('@/views/order/OrderProgress'),
     name: 'OrderProgress',
     meta: { title: '订单进度'},
    },
    {
      path: '/orderSignature',
      component: () => import('@/views/order/OrderSignature'),
      meta: { title: '订单签字'}
    },
    {
     path: '/orderEvaluate',
     component: () => import('@/views/order/OrderEvaluate'),
     name: 'OrderEvaluate',
     meta: { title: '订单评价'},
    },

    // 自定义评价
    {
     path: '/orderEvaluateNew',
     component: () => import('@/views/order/OrderEvaluateNew'),
     name: 'OrderEvaluateNew',
     meta: { title: '订单评价'},
    },
    {
     path: '/orderSend',
     component: () => import('@/views/order/OrderSend'),
     name: 'OrderSend',
     meta: { title: '订单寄修'},
    },

    {
     path: '/orderSuccess',
     component: () => import('@/views/order/OrderSuccess'),
     name: 'OrderSuccess',
     meta: { title: '报修成功'},
    },
    {
     path: '/orderTags',
     component: () => import('@/views/order/OrderTags'),
     name: 'OrderSuccess',
     meta: { title: '自定义标签'},
    },
    {
      path: '/orderElec',
      component: () => import('@/views/order/OrderElec'),
      name: 'OrderElec',
      meta: { title: '电子订单'},
    },
    {
     path: '/orderQuote',
     component: () => import('@/views/order/OrderQuote'),
     name: 'OrderQuote',
     meta: { title: '报价单'},
    },

    {
      path: '/orderServiceProgress',
      component: () => import('@/views/orderService/OrderServiceProgress'),
      name: 'OrderServiceProgress',
      meta: { title: '服务单进度'},
    },

    {
      path: '/orderBeCheckDetail',
      component: () => import('@/views/order/OrderBeCheckDetail'),
      name: 'OrderBeCheckDetail',
      meta: { title: '审核单详情'},
    },
    {
      path: '/orderBeCheckProgress',
      component: () => import('@/views/order/OrderBeCheckProgress'),
      name: 'OrderBeCheckProgress',
      meta: { title: '审核单进度'},
    },
    {
      path: '/orderBeCheckFlow',
      component: () => import('@/views/order/OrderBeCheckFlow'),
      name: 'OrderBeCheckFlow',
      meta: { title: '审核步骤'},
    },
    {
      path: '/orderTrack',
      component: () => import('@/views/order/OrderTrack'),
      name: 'OrderTrack',
      meta: { title: '轨迹显示'},
    },

    {
      path: '/OrderCancel',
      component: () => import('@/views/order/OrderCancel'),
      name: 'OrderCancel',
      meta: { title: '取消订单'},
     },

     {
      path: '/OrderRefuse',
      component: () => import('@/views/order/OrderRefuse'),
      name: 'OrderRefuse',
      meta: { title: '拒绝验收'},
     },

    {
     path: '/addressAdd',
     component: () => import('@/views/address/AddressAdd'),
     name: 'AddressAdd',
     meta: { title: ''},
    },
     {
     path: '/addressEdit',
     component: () => import('@/views/address/AddressEdit'),
     name: 'AddressEdit',
     meta: { title: ''},
    },
    {
     path: '/addressList',
     component: () => import('@/views/address/AddressList'),
     name: 'AddressList',
     meta: { title: ''},
    },

    {
     path: '/noticeList',
     component: () => import('@/views/notice/NoticeList.vue'),
     name: 'NoticeList',
     meta: { title: ''},
    },


      {
     path: '/mapOrder',
     component: () => import('@/views/amap/MapOrder'),
     name: 'MapOrder',
     meta: { title: ''},
    },

    {
     path: '/messageBoard',
     component: () => import('@/views/message/MessageBoard.vue'),
     name: 'MessageBoard',
     meta: { title: ''},
    },



    {
      path: '/rtcRecord',
      component: () => import('@/views/rtc/RtcRecord.vue'),
      name: 'RtcRecord',
      meta: { title: ''},
     },



    {
     path: '/companyList',
     component: () => import('@/views/company/CompanyList'),
     name: 'CompanyList',
     meta: { title: ''},
    },
    {
     path: '/joinCompanyList',
     component: () => import('@/views/company/JoinCompanyList'),
     name: 'JoinCompanyList',
     meta: { title: ''},
    },
    {
     path: '/companyVersion',
     component: () => import('@/views/company/CompanyVersion'),
     name: 'CompanyVersion',
     meta: { title: ''},
    },
    {
     path: '/companyCreate',
     component: () => import('@/views/company/CompanyCreate'),
     name: 'CompanyCreate',
     meta: { title: ''},
    }, {
     path: '/companySuccess',
     component: () => import('@/views/company/CompanySuccess'),
     name: 'CompanySuccess',
     meta: { title: ''},
    },
    {
     path: '/companyEdit',
     component: () => import('@/views/company/CompanyEdit'),
     name: 'CompanyEdit',
     meta: { title: ''},
    },
      {
     path: '/companySearch',
     component: () => import('@/views/company/CompanySearch'),
     name: 'CompanySearch',
     meta: { title: ''},
    },
   {
     path: '/companyJoin',
     component: () => import('@/views/company/CompanyJoin'),
     name: 'CompanyJoin.',
     meta: { title: ''},
    },
    {
      path: '/companyInvite',
      component: () => import('@/views/company/CompanyInvite'),
      name: 'companyInvite.',
      meta: { title: '邀请你加入'},
     },

    {
     path: '/deviceDetail',
     component: () => import('@/views/device/DeviceDetail'),
     name: 'DeviceDetail',
     meta: { title: ''},
    },
    {
      path: '/deviceManufacturerWarranty',
      component: () => import('@/views/device/deviceManufacturerWarranty'),
      name: 'DeviceManufacturerWarranty',
      meta: { title: ''},
     },
    {
     path: '/deviceList',
     component: () => import('@/views/device/DeviceList'),
     name: 'DeviceList',
     meta: { title: ''},
    },
    {
      path: '/deviceSearch',
      component: () => import('@/views/device/DeviceSearch'),
      name: 'DeviceSearch',
      meta: { title: ''},
     },


    {
     path: '/servicerConfirm',
     component: () => import('@/views/servicer/ServicerConfirm'),
     name: 'ServicerConfirm',
     meta: { title: ''},
    },
    {
     path: '/servicerList',
     component: () => import('@/views/servicer/ServicerList'),
     name: 'ServicerList',
     meta: { title: ''},
    },
    {
     path: '/servicerPossible',
     component: () => import('@/views/servicer/ServicerPossible'),
     name: 'ServicerPossible',
     meta: { title: ''},
    },
    {
     path: '/servicerSearch',
     component: () => import('@/views/servicer/ServicerSearch'),
     name: 'ServicerSearch',
     meta: { title: ''},
    },
    {
      path: '/servicerInfo',
      component: () => import('@/views/servicer/ServicerInfo'),
      name: 'ServicerInfo',
      meta: { title: ''},
     },
    {
      path: '/servicerSearchName',
      component: () => import('@/views/servicer/servicerSearchName'),
      name: 'servicerSearchName',
      meta: { title: ''},
    },
    {
     path: '/passwordChangeMob',
     component: () => import('@/views/user/PasswordChangeMob'),
     name: 'PasswordChangeMob',
     meta: { title: ''},
    },
    {
     path: '/passwordChange',
     component: () => import('@/views/user/PasswordChange'),
     name: 'PasswordChange',
     meta: { title: ''},
    },
    {
     path: '/nameChange',
     component: () => import('@/views/user/NameChange'),
     name: 'NameChange',
     meta: { title: ''},
    },
    {
     path: '/passwordForgetMob',
     component: () => import('@/views/user/PasswordForgetMob'),
     name: 'PasswordForgetMob',
     meta: { title: ''},
    },
    {
     path: '/passwordForget',
     component: () => import('@/views/user/PasswordForget'),
     name: 'PasswordForget',
     meta: { title: ''},
    },

    {
     path: '/phoneChange',
     component: () => import('@/views/user/PhoneChange'),
     name: 'PhoneChange',
     meta: { title: ''},
    },
    {
     path: '/userComplete',
     component: () => import('@/views/user/UserComplete'),
     name: 'UserComplete',
     meta: { title: '完善信息'},
    },
    {
     path: '/userFeedback',
     component: () => import('@/views/user/UserFeedback'),
     name: 'UserFeedback',
     meta: { title: ''},
    },
    {
     path: '/userInfor',
     component: () => import('@/views/user/UserInfor'),
     name: 'UserInfor',
     meta: { title: ''},
    },
    {
     path: '/userStatic',
     component: () => import('@/views/user/UserStatic'),
     name: 'UserStatic',
     meta: { title: ''},
    },

     {
     path: '/customerInvite',
     component: () => import('@/views/share/CustomerInvite'),
     name: 'CustomerInvite',
     meta: { title: ''},
    },
     {
     path: '/friendInvite',
     component: () => import('@/views/share/FriendInvite'),
     name: 'FriendInvite',
     meta: { title: ''},
    },
    {
     path: '/servicerInvite',
     component: () => import('@/views/share/ServicerInvite'),
     name: 'ServicerInvite',
     meta: { title: ''},
    },
    {
     path: '/bind/authCheck',
     component: () => import('@/views/bind/AuthCheck'),
     name: '/authCheck',
     meta: { title: ''},
    },
    {
      path: '/inviteUser',
      component: () => import('@/views/other/invite'),
      name: '/inviteUser',
      meta: { title: ''},
     },
     {
      path: '/inviteSuccess',
      component: () => import('@/views/other/inviteSuccess'),
      name: '/inviteSuccess',
      meta: { title: ''},
     },

     {
      path: '/inviteFailed',
      component: () => import('@/views/other/inviteFailed'),
      name: '/inviteFailed',
      meta: { title: ''},
     },
    {
     path: '/scanConfirm',
     component: () => import('@/views/scan/ScanConfirm'),
     name: 'ScanConfirm',
     meta: { title: ''},
    },
    {
        path: '/error/error',
        component: () => import('@/views/error/error'),
        name: 'error',
        meta: { title: ''},
    },

    {
      path: '/',
      redirect: '/bind/authCheck',
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/components/NotFound'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js